import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import { useAddDoctorsMasterData } from '../../hooks/useDoctorMasterData';
import { toast } from 'react-toastify';
import doctorMasterDataService from '../../services/doctorMasterDataService';

const HCPForm = ({ open, onClose, formData, onInputChange }) => {
  const addHCP = useAddDoctorsMasterData();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);

      const duplicateField = await doctorMasterDataService.checkDuplicate(formData);

      // Check for duplicates
      if (duplicateField) {
        toast.error(`${duplicateField} already exists`);
        setIsSubmitting(false);
        return;
      }

      // await addHCP.mutateAsync(formData);
      await addHCP.mutateAsync({
        ...formData,
        created_at: new Date().toISOString()
      });
      toast.success('HCP added successfully');
      onClose();
    } catch (error) {
      console.error('Error adding HCP:', error);
      toast.error(error.message || 'Error adding HCP');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle className="bg-blueColor text-white py-4">
        <i className="fas fa-plus text-xl mx-2"></i>
        <span className="text-xl font-semibold">Add New HCP</span>
      </DialogTitle>
      <DialogContent className="mt-4">
        <div className="grid grid-cols-2 gap-4 p-4">
          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              First Name <span className="text-red-500">*</span>
            </label>
            <input
              name="first_name"
              value={formData.first_name}
              onChange={onInputChange}
              type="text"
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Family Name <span className="text-red-500">*</span>
            </label>
            <input
              name="family_name"
              value={formData.family_name}
              onChange={onInputChange}
              type="text"
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              name="email"
              value={formData.email}
              onChange={onInputChange}
              type="email"
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Phone Number
            </label>
            <input
              name="phone_number"
              value={formData.phone_number}
              onChange={onInputChange}
              type="tel"
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
            />
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Specialty
            </label>
            <input
              name="specialty"
              value={formData.specialty}
              onChange={onInputChange}
              type="text"
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
            />
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Organization
            </label>
            <input
              name="organization"
              value={formData.organization}
              onChange={onInputChange}
              type="text"
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
            />
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Medical License <span className="text-red-500">*</span>
            </label>
            <input
              name="medical_license"
              value={formData.medical_license}
              onChange={onInputChange}
              type="text"
              required
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
            />
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              National ID <span className="text-red-500">*</span>
            </label>
            <input
              name="national_id"
              value={formData.national_id}
              onChange={onInputChange}
              type="text"
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              APO Number <span className="text-red-500">*</span>
            </label>
            <input
              name="APO_number"
              value={formData.APO_number}
              onChange={onInputChange}
              type="text"
              required
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
            />
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Practice/Sector <span className="text-red-500">*</span>
            </label>
            <select
              name='industry_area'
              onChange={onInputChange}
              value={formData.industry_area}
              required
              className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
            >
              <option value="" hidden>Select Practice/Sector</option>
              <option value="private">Private</option>
              <option value="public">Public</option>
            </select>
          </div>
        </div>
        <div className="flex justify-end gap-4 mt-6 p-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            data-track="save-hcp-button"
            data-module="HCPs"
            onClick={handleSubmit}
            className="px-4 py-2 bg-blueColor text-white rounded"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Saving...' : 'Save'}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HCPForm; 